// src/pages/HomePage.jsx
//import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import RemindersLogic from "../components/RemindersLogic";
//const API = process.env.REACT_APP_API_URL;


const PAGES = {
  reminder: { sidebar: "erinnerungen", title: "Allgemeine Erinnerungen" },
  activation: { sidebar: "aktivierungen", title: "Aktivierungen" },
  query: { sidebar: "abfragen", title: "Abfragen" },
};

export default function GeneralReminders({ activation = false, query = false }) {
  const pageType = activation ? "activation" : query ? "query" : "reminder";
  const page = PAGES[pageType];

  return (
    <div className="flex min-h-screen bg-[#cdeaff]">
      <Sidebar active={page.sidebar} />
      <main className="flex-1 px-0 pt-6 pb-0">
        <div className="w-full h-full rounded-tl-xl border border-black/10 bg-white/60 p-6 backdrop-blur">
          <div className="flex items-center justify-between">
            <h1 className="text-3xl font-semibold text-gray-900">{page.title}</h1>
          </div>
          {query && (
            <p className="mt-2 text-sm text-gray-700">
              Fragen, die Steffi mehreren Bewohnern stellt. Abfragen für einzelne Bewohner findest du im Bewohnerprofil unter „Abfragen“.
            </p>
          )}
           <RemindersLogic multi templateType={pageType} />
        </div>
      </main>
    </div>
  );
}
